
import { lettersList } from "constants/superAdmin";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const getSALettersList = async (
  dispatch,
  pageNum,
  filterParams,
) => {
  try {
    const res = await api.sa_letters_list(pageNum, filterParams,);
    dispatch({ type: lettersList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: lettersList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};


export const letterRequestApproval = async (letterID,bodyData) => {
  try {
    const res = await api.letter_request_approval(letterID,bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};